import Modal from "react-modal";
import AgoraChat from "../../../agora-chat";
import { useSwipeable } from "react-swipeable";
import { useEffect, useState } from "react";
import { close, No_Interactions } from "../../../../assets/icons";
import InteractionProductList from "../../../interactions/components/interactionProductList";
import useAppAccessor from "../../../../hooks/useappAccessor";
import DraggableList from "../../../interactions/components/draggableList";
import DraggableListMobile from "../../../interactions/components/draggableListMobile";

import { getProductDetail } from "../../../interactions/interaction.actions";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import InteractionShoppingCart from "../../../interactions/components/interactionShoppingCart";
import InteractionShoppingCartTranont from "../../../interactions/components/interactionShoppingCartTranont";
import InteractionShoppingCartPartnerCo from "../../../interactions/components/interactionShoppingCartPartnerCo";
import React, { useRef } from 'react';

const customStyles = {
  content: {
    top: "30%",
    left: 0,
    right: 0,
    border: 0,
    bottom: 0,
    borderRadius: 0,
    backgroundColor: "white",
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24,0.5)",
    zIndex: 99999,
  },
};

function ModalBottomChatMobile(props: any) {
  const [isEditable, setIsEditable] = useState(false);
  const { getInteractions } = useAppAccessor();
  const { interactionData } = getInteractions();
  const [closing, setClosing] = useState(false);
  const [isShowIframe, setIsShowIframe] = useState(false);
  const [iframeURL, setIframeURL] = useState("");
  const [showProductList,setShowProductList] = useState(false);
  const [toCart,setToCart] = useState(false)
  const { productDetail} = getInteractions();
  const dispatch = useAppDispatch();
  const { getLiveMainData, getUserData } = useAppAccessor();
  const { language, client } = getUserData();

  const handleClose = () => {
    
    setClosing(true);
    
    
    setTimeout(() => {
      setShowProductList(false);
      dispatch(getProductDetail({}));
      props.onClose();
      setClosing(false);
    }, 600);
  };

  useEffect(() => {
      const iFrameContainer = document.getElementById('iFrameContainer');
      if (iFrameContainer) {
        iFrameContainer.scrollTop = 0;
      }
    }
  , [showProductList]);

  useEffect(() => {
      const iFrameContainer = document.getElementById('iFrameContainer');
      if (iFrameContainer) {
        iFrameContainer.scrollTop = 0;
      }
    }
  , [toCart]);

  const handlers = useSwipeable({
    onSwipedDown: ()=>{},
  });

  return (
    <Modal
      isOpen={true}
      onRequestClose={handleClose}
      closeTimeoutMS={600}
      style={{
        ...customStyles,
        content: {
          overflow: 'hidden', 
          ...customStyles.content,
          display: props.modalIsOpen ? "block" : "none",
          transform: closing ? "translateY(100%)" : "translateY(0%)",
          transition: "transform 0.4s ease-in-out",
          paddingLeft: 20,
          paddingRight: 20,
          paddingBottom: 0,
          paddingTop: 0,
        },
        overlay: {
          ...customStyles.overlay,
          display: props.modalIsOpen ? "block" : "none",
        },
      }}
      contentLabel="Example Modal"
    >
      <div {...handlers} className="flex w-full h-full" style={{overflow:'hidden'}} >
      <div className="w-full h-12 flex items-center justify-center">
        
          {/* <button onClick={handleClose} style={{ position: 'absolute', top: '5px', right: '10px', zIndex:190 }}>
            <img
                  src={close}
                  alt="close"
                  height={24}
                  width={24}
                  style={{ height: "24px" , margin: '3px' }}
                  className="cursor-pointer"
                ></img>
            </button> */}
          </div>
          <div  className=" overflow-y-auto listContainer" id="iFrameContainer" style={/Mobi|Android/i.test(navigator.userAgent) ? {marginLeft:'-5%'} : interactionData.length > 0 ? {marginLeft:'-5%', backgroundColor:'white'} : {marginLeft:'-5%', backgroundColor:'rgb(65, 65, 65)'}}>
          <div style={showProductList && !toCart ?{marginTop:'0px', overflow:'hidden', width:'100%'} : {marginTop:'0px', overflow:'hidden', width:'100%'}}>
          {interactionData.length === 0 && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop:'200px',
          }}
        >
            <>
              <img src={No_Interactions} className="mx-auto mt-10" style={{height: 74, width: 74}}></img>
              <div style={{width:'269px', textAlign:'center', marginTop:'10px'}}>
                <p style={{color:'#DEDEDE', fontSize:'16px', fontWeight:'400', lineHeight:'28px'}}>{language['no_interactions']}.</p>
              </div>
            </>
        </div>
        )}

      {!showProductList && interactionData.length > 0 && (
              <InteractionProductList
              data={interactionData.filter((item: any) => item.interaction_type === "shop_com")}
              toggleProductList={(flag: boolean)=>{setShowProductList(flag)}}
              toDetail = {() => {setShowProductList(false); setToCart(false);} }
              toCart = {()=>{setIsEditable(false); setShowProductList(true); setToCart(true);
                var tmpProduct = productDetail;
                  tmpProduct['fromCarsoul'] = false;
                  dispatch(getProductDetail(tmpProduct));
              }}
              iframeURL={(url: any) => {
                setIframeURL(url);
              }}
              showIframe={(flag: any) => {
                setIsShowIframe(flag);
              }}
            ></InteractionProductList>
            )}

{
              !isEditable && showProductList && (
                client.toLowerCase().includes('tranont') ? (
                  <InteractionShoppingCartTranont showCart={toCart} toggleProductList={(flag: boolean) => { setShowProductList(flag); }} />
                ) : client.toLowerCase().trim().includes('partner.co') ? (
                  <InteractionShoppingCartPartnerCo showCart={toCart} toggleProductList={(flag: boolean) => { setShowProductList(flag); }} />
                ) : (
                  <InteractionShoppingCart showCart={toCart} toggleProductList={(flag: boolean) => { setShowProductList(flag); }} />
                )
              )
            }

          </div>
          </div>
        
      </div>
    </Modal>
  );
}

export default ModalBottomChatMobile;
